export default {
      id: "i-sber-logo-min-usage",
      viewBox: "0 0 33 29",
      url: __webpack_public_path__ + "img/sprite.svg#i-sber-logo-min",
      toString: function () {
        return this.url;
      }
    }